export const LogoutIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="currentColor"
    color={"#1b51dc"}
  >
    <g fill="currentColor" fillRule="evenodd" clipRule="evenodd">
      <path d="M2 4a1 1 0 0 1 1-1h8a1 1 0 1 1 0 2H4v14h7a1 1 0 1 1 0 2H3a1 1 0 0 1-1-1V4Z" />
      <path d="M15.793 6.793a1 1 0 0 1 1.414 0l4.5 4.5a1 1 0 0 1 0 1.414l-4.5 4.5a1 1 0 0 1-1.414-1.414L18.586 13H8a1 1 0 1 1 0-2h10.586l-2.793-2.793a1 1 0 0 1 0-1.414Z" />
    </g>
  </svg>
);
